module.exports = __webpack_public_path__ + "assets/img/266d9e2a3a84f9b5bbc6a8ad13a17d82.svg";